@if (navbar.userAccess?.Mailbox=='Full' || navbar.userAccess?.Mailbox=='Readonly') {
<div class="row m-0 h-100">
	<div class="cust-col-1 border-end bg-white">
		<!-- Header -->
		<div class="search-container flex-shrink-0">
			@if(category!=''){
			<div class="d-flex align-items-center justify-content-between mb-3">
				<h5 class="m-0 fw-bold text-muted text-capitalize">{{category}}</h5>
			</div>
			<div class="input-group input-group-sm modern-search mb-2">
				<span class="input-group-text border-0"><fa-icon [icon]="['fas', 'search']"
						class="text-muted"></fa-icon></span>
				<input placeholder="Search emails..." [formControl]="searchControl"
					class="form-control border-0 modern-search-input shadow-none" />
				@if (searchControl.value) {
				<button class="btn border-0" (click)="clearFilter()" matTooltip="Clear">
					<fa-icon [icon]="['fas', 'times']" class="text-muted"></fa-icon>
				</button>
				}
			</div>
			}

			<!-- Action Buttons -->
			@if (!mailboxReadonly && navbar.userAccess?.Mailbox=='Full') {
			<div class="d-flex align-items-center gap-2 flex-wrap mt-2">
				@if(category!='draft'){
				<mat-checkbox color="primary" [(ngModel)]="allChecked" (change)="selectAll()" class="mt-1 me-1">
				</mat-checkbox>
				}
				@if(category == "spam" || category == "unlinked"){
				<button type="button" class="btn btn-sm rounded-pill"
					[ngClass]="category=='spam'?'btn-outline-success':'btn-outline-danger'"
					(click)="openMoveMailModal()" [disabled]="loaderMoveMail">
					@if (loaderMoveMail) {
					<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas', category=='spam'?'check':'exclamation']"></fa-icon>
					}
					<span class="ms-1">{{category=='spam'?'Mark as not spam':'Mark as spam'}}</span>
				</button>
				}
				@if (category!='draft' && category!='spam' && !apptId) {
				<button type="button" class="btn btn-sm btn-outline-success rounded-pill" (click)="linkMails()">
					<fa-icon [icon]="['fas', 'link']"></fa-icon>
					<span class="ms-1">Link</span>
				</button>
				}
				@if(apptId){
				<button type="button" class="btn btn-sm btn-outline-primary rounded-pill"
					(click)="markCaseMailsAsReplied()">
					({{mailList.length}})
					<fa-icon [icon]="['fas', 'envelope']"></fa-icon>
					<span class="ms-1">Mark all as replied</span>
				</button>
				<button type="button" class="btn btn-sm btn-outline-danger rounded-pill" (click)="unlinkMails()">
					<fa-icon [icon]="['fas', 'unlink']"></fa-icon>
					<span class="ms-1">Unlink</span>
				</button>
				}
			</div>
			}
		</div>

		<!-- Mail List -->
		<div class="flex-grow-1 position-relative">
			<cdk-virtual-scroll-viewport itemSize="{{itemSize}}" (scrolledIndexChange)="scrollEvent($event);"
				class="position-absolute top-0 bottom-0 start-0 end-0 w-100">
				<table class="table mail-table w-100">
					<tbody>
						<tr *cdkVirtualFor="let mail of mailList; let i = index"
							[ngClass]="{'unread': mail.email_status=='unread'}" [routerLinkActive]="['active-link']"
							class="mail-item border-bottom">
							<td class="p-0 border-0" [routerLink]="getMailLink(mail.id)">
								<div class="d-flex align-items-center p-2 h-100 w-100 text-decoration-none text-dark">
									<!-- Checkbox -->
									@if(category!='draft' && !mailboxReadonly && navbar.userAccess?.Mailbox=='Full'){
									<div class="me-2">
										<mat-checkbox color="primary" [(ngModel)]="mail.selected"
											(change)="selectMail()">
										</mat-checkbox>
									</div>
									}

									<!-- Direction Icon -->
									<div class="mail-direction me-3">
										@if (mail.email_status == 'unread' || mail.email_status == 'read') {
										<div class="direction-icon incoming">
											<app-mail-dir-icon [direction]="'in'"></app-mail-dir-icon>
										</div>
										} @else if (mail.email_status == 'sent' || mail.email_status == 'draft') {
										<div class="direction-icon outgoing">
											<app-mail-dir-icon [direction]="'out'"></app-mail-dir-icon>
										</div>
										}
									</div>
									<!-- Mail Content -->
									<div class="flex-grow-1 min-w-0">
										<div class="d-flex justify-content-between align-items-baseline mb-1">
											<p class="mb-0 text-truncate mailbox-from flex-grow-1 pe-2">
												@if(mail.email_status =='read' || mail.email_status =='unread'){
												@if (mail.from_name) {
												<span matTooltip="{{mail.from_email}}">{{mail.from_name | limitTo :
													'30'}}</span>
												}@else {
												<span matTooltip="{{mail.from_email}}">{{mail.from_email | limitTo :
													'30'}}</span>
												}
												}@else if(mail.email_status =='sent' || mail.email_status =='draft'){
												@if (mail.to_name) {
												<span>{{mail.to_name | limitTo : '30'}}</span>
												}@else {
												<span>
													@for (data of mail.toEmailList; track $index) {
													<span matTooltip="{{data}}">{{data | limitTo : '30'}} </span>
													}
												</span>
												}
												}
											</p>
											<span class="mailbox-date text-muted ms-2 flex-shrink-0">{{mail.messageDate
												| timeAgo}}</span>
										</div>
										<div class="d-flex justify-content-between align-items-center">
											<p class="mailbox-subject mb-0 text-truncate pe-2 flex-grow-1">
												{{mail.subject ? (mail.subject | limitTo : '40') : '(No Subject)'}}
											</p>

											<!-- Badges & Icons -->
											<div class="d-flex align-items-center gap-2 flex-shrink-0">
												@if (mail.email_status=='draft' && apptId) {
												<span class="badge bg-danger rounded-pill">Draft</span>
												}
												@if (mail.attachmentsArr.length) {
												<fa-icon [icon]="['fas', 'paperclip']" class="text-muted"
													matTooltip="Contains attachments"></fa-icon>
												}
												@if (mail.sent_by_name) {
												<span class="badge bg-secondary rounded-pill"
													matTooltip="Sent By:{{mail.sent_by_name}}">
													{{getInitials(mail.sent_by_name)}}
												</span>
												}
												<fa-icon [icon]="['fas', 'info-circle']" class="text-muted ms-1"
													matTooltip="Info" role="button"
													(click)="showMailActions(mail); $event.stopPropagation()"></fa-icon>
											</div>
										</div>
									</div>
								</div>
							</td>
						</tr>

						<!-- Loaders & States -->
						@if(isListLoading){
						<tr>
							<td class="text-center p-4 border-0">
								<mat-spinner class="mail-loader mx-auto" diameter="30"></mat-spinner>
							</td>
						</tr>
						}
						@if(mailList.length==0 && !isListLoading){
						<tr>
							<td class="text-center p-5 border-0 text-muted">
								<fa-icon [icon]="['fas', 'inbox']" size="3x" class="mb-3 text-light"></fa-icon>
								<p class="m-0">No Mail</p>
							</td>
						</tr>
						}
						@if(!isListFinished && !apptId){
						<tr>
							<td class="text-center p-3 border-0">
								<button (click)="loadMails(false)"
									class="btn btn-outline-primary btn-sm rounded-pill px-4">
									Load More...
								</button>
							</td>
						</tr>
						}
						@if(apptId){
						<tr>
							<td class="text-center p-3 border-0">
								<button (click)="loadMails(false)"
									class="btn btn-outline-primary btn-sm rounded-pill px-4">
									Refresh
								</button>
							</td>
						</tr>
						}
					</tbody>
				</table>
			</cdk-virtual-scroll-viewport>
		</div>
	</div>

	<div class="cust-col-2 bg-light">
		<div class="h-100 selected-mail-container position-relative">
			<div class="h-100" [@routeAnimations]="prepareRoute(o)" [ngClass]="{'d-none':isMailSelected()}">
				<router-outlet (activate)='onActivate($event)' (deactivate)='onDeactivate($event)'
					#o="outlet"></router-outlet>
				@if (showSelectMailMsg) {
				<div class="h-100 d-flex flex-column justify-content-center align-items-center text-muted">
					<fa-icon [icon]="['fas', 'envelope-open-text']" size="4x"
						class="mb-3 text-secondary opacity-50"></fa-icon>
					<h4 class="fw-normal">Select an email to read</h4>
				</div>
				}
			</div>
			<div class="h-100 d-flex justify-content-center align-items-center text-muted"
				[ngClass]="{'d-none':!isMailSelected()}">
				<div class="text-center">
					<fa-icon [icon]="['fas', 'tasks']" size="4x" class="mb-3 text-secondary opacity-50"></fa-icon>
					<h4 class="fw-normal">{{isMailSelected()}} {{isMailSelected()>1?'emails':'email'}} selected</h4>
				</div>
			</div>
		</div>
	</div>
</div>
} @else {
<div class="d-flex h-100 justify-content-center align-items-center bg-light">
	<div class="text-center text-muted">
		<fa-icon [icon]="['fas', 'lock']" size="3x" class="mb-3 text-light"></fa-icon>
		<h3>You don't have access to this section.</h3>
	</div>
</div>
}

<div class="modal fade" id="mailActionModal" role="dialog" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content border-0 shadow">
			<div class="modal-header border-bottom-0 pb-0">
				<h5 class="modal-title fw-bold">Mail Details</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				@if(mailAction){
				<div class="card bg-light border-0">
					<div class="card-body">
						<div class="d-flex justify-content-between mb-2">
							<span class="text-muted fw-semibold">Created By</span>
							<span class="fw-bold">{{mailAction.created_by_name || "-"}}</span>
						</div>
						<div class="d-flex justify-content-between">
							<span class="text-muted fw-semibold">Updated By</span>
							<span class="fw-bold">{{mailAction.updated_by_name || "-"}}</span>
						</div>
					</div>
				</div>
				}
			</div>
			<div class="modal-footer border-top-0 pt-0">
				<button type="button" class="btn btn-secondary rounded-pill px-4" data-bs-dismiss="modal">Close</button>
			</div>
		</div>
	</div>
</div>